module.exports = __webpack_public_path__ + "static/media/pro1.ac4d6fd3.png";